<template>
  <AppFormGroup>
    <AppField path="jointEnabled" />
  </AppFormGroup>
</template>

<script setup lang="ts">
  import {
    AppField,
    AppFormGroup,
  } from "@versatile-credit-apply/components/form"

  import { useProviderI18n } from "@versatile-credit-apply/sdk"
  import type { FormSectionProps } from "./form-section-api"

  const props = defineProps<FormSectionProps>()

  useProviderI18n(() => props.providerKey)
</script>

<i18n lang="yaml" locale="en">
appFields:
  jointEnabled:
    description: >
      If you apply with a Joint Applicant, each of you will be jointly and individually responsible
      for obligations under the Agreement and by signing below, you each agree that you intend to
      apply for joint credit.
    label: Add a joint applicant
</i18n>

<i18n lang="yaml" locale="synchrony_standard_en">
appFields:
  jointEnabled:
    description: >
      An additional card will be issued to the person indicated as the Joint Applicant.
      The applicant (and joint applicant, if any) will be liable for all transactions
      made on the account including those made by any authorized user.
</i18n>
